import { Editor, Transforms } from 'slate';
export function moveTopLevelElement(editor, srcIndices, dstIndex) {
    if (srcIndices.includes(dstIndex)) {
        return;
    }
    const sortedSrcIndices = srcIndices.sort();
    // Move forward
    if (dstIndex > sortedSrcIndices[sortedSrcIndices.length - 1]) {
        Editor.withoutNormalizing(editor, () => {
            for (let i = 0; i < sortedSrcIndices.length; ++i) {
                Transforms.moveNodes(editor, {
                    at: [sortedSrcIndices[0]],
                    to: [dstIndex],
                });
            }
            // Normalize the removed place
            editor.normalizeNode([
                editor.children[sortedSrcIndices[0]],
                [sortedSrcIndices[0]],
            ]);
            // Normalize the newly inserted place
            const dstNormalizeIdx = dstIndex - (srcIndices.length - 1);
            editor.normalizeNode([
                editor.children[dstNormalizeIdx],
                [dstNormalizeIdx],
            ]);
        });
        return;
    }
    // Move backward
    Editor.withoutNormalizing(editor, () => {
        for (let i = 0; i < sortedSrcIndices.length; ++i) {
            Transforms.moveNodes(editor, {
                at: [sortedSrcIndices[i]],
                to: [dstIndex + i],
            });
        }
        // Normalize the removed place
        const srcNormalizeIdx = sortedSrcIndices[sortedSrcIndices.length - 1];
        editor.normalizeNode([editor.children[srcNormalizeIdx], [srcNormalizeIdx]]);
        // Normalize the newly inserted place
        editor.normalizeNode([editor.children[dstIndex], [dstIndex]]);
    });
}
//# sourceMappingURL=moveTopLevelElement.js.map